<div class="bg-main">
    <header class="header">
        <site-header></site-header>
    </header>
    <br/>
    <router-outlet></router-outlet>
    <site-footer></site-footer>
</div>
